import { vaultFetch, qs } from './vault-api-core.ts'

export interface VaultAuditRow {
  id: string
  actor: string
  action: string
  entityType: string
  entityId: string
  createdAt: string
  details: Record<string, unknown>
  [key: string]: unknown
}

// ── audit ───────────────────────────────────────────────────────────────
export async function listAudit(
  rootId: string,
  options?: { limit?: number; before?: string },
): Promise<VaultAuditRow[]> {
  const { rows } = await vaultFetch<{ rows: VaultAuditRow[] }>(
    `/vault/admin/${rootId}/audit${qs({
      limit: options?.limit?.toString(),
      before: options?.before,
    })}`,
  )
  return rows
}
